import { NgModule, Component, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AutoLocation } from '../enums/gateway.enum';

@Pipe({
  name: "autoLocationPipe"
})
export class AutoLocationPipe implements PipeTransform {
  translation: any;

  constructor(private translate: TranslateService) {
    this.translate.get('Gateway').subscribe(
      data => {
        this.translation = data;
      }
    )
  }

  transform(value: string): string {
    let text;
    switch (value) {
      case AutoLocation.YesAuto:
        text = this.translation.YesAuto;
        break;
      case AutoLocation.NoAuto:
        text = this.translation.NoAuto;
        break;
    }
    return text;
  }
}
